import { Divider } from "component/divider";
import { Section } from "component/section";
import React, { Suspense, useEffect } from "react";
import { Box, Page } from "zmp-ui";
import { SuccessOrder } from "./component/successOrder";
import { SuccessDeliveryInfo } from "./component/deliveryInfo";
import { useOrderDetails } from "./hooks/useOrderDetails";
import { useRecoilValue } from "recoil";
import { orderState } from "state";
import { ProductItems } from "./productItem";
import { PowerBy } from "../../component/powerBy";

export const OrderDetail = () => {
  return (
    <Page className="relative flex-1 flex flex-col bg-white shopping-cart__content">
      <SuccessOrder />
      <SuccessDeliveryInfo />
      <Divider />
      <ProductList />
      <PowerBy />
    </Page>
  );
};

export const ProductListContent = () => {
  const orders = useRecoilValue(orderState);

  const { getOrderDetail } = useOrderDetails();
  useEffect(() => {
     if(!!!orders?.id)
       getOrderDetail();
  }, []);

  return (
    <Section>
      <Box>
        {orders?.order_details && (
          <ProductItems mode="complete" products={orders?.order_details} />
        )}
      </Box>
    </Section>
  );
};

export const ProductList = () => {
  return (
    <Suspense>
      <ProductListContent />
    </Suspense>
  );
};
